import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { truncate } from 'lodash';
import { DataStorageService } from 'src/app/core/services/dataStorage/data-storage.service';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION,
	PARAM_LABEL_USER
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { Authority } from 'src/app/shared/models/security/authority';

@Component({
	selector: 'app-nav-parametrage',
	templateUrl: './nav-parametrage.component.html',
	styleUrls: ['./nav-parametrage.component.scss']
})
export class NavParametrageComponent implements OnInit {
	tabs: any[];
	detailTab: any;

	@Input() addable = false;
	@Input() isImportable = false;
	@Input() isExportable = false;
	@Output() importingEvent: EventEmitter<MouseEvent> =
		new EventEmitter<MouseEvent>();
	@Output() exportingEvent: EventEmitter<MouseEvent> =
		new EventEmitter<MouseEvent>();
	@Output() addEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

	user: User;

	constructor(private router: Router, private facade: FacadeService) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();

		const labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);

		/**
		 * Elements de la navbar dans gestion des données
		 */
		this.tabs = [];

		// if (
		// 	(this.facade.dataStorageService.isSESSAD() ||
		// 		this.facade.dataStorageService.isSAAD()) &&
		// 	this.userAsAnyAuthority([
		// 		Authority.DIRECTEUR_STRUCTURE,
		// 		Authority.RESPONSABLE_CENTRE,
		// 		Authority.PLANIFICATEUR
		// 	])
		// ) {
		// 	this.tabs.push({
		// 		name: 'Spécialités',
		// 		path: '/gestion/specialites/list',
		// 		parentPath: '/gestion/specialites'
		// 	});

		// 	this.detailTab = { path: '/gestion/specialites/detail' };
		// 	this.tabs.push({
		// 		name: 'Types de ' + labelIntervention,
		// 		path: '/gestion/mission/type/list',
		// 		parentPath: '/gestion/mission/type'
		// 	});
		// 	if (this.facade.dataStorageService.isFunderActive()) {
		// 		this.tabs.push({
		// 			name: 'Financeurs',
		// 			path: '/gestion/funders/list',
		// 			parentPath: '/gestion/funders'
		// 		});
		// 	}
		// }

		// if (
		// 	this.facade.dataStorageService.isSESSAD() &&
		// 	this.userAsAnyAuthority([
		// 		Authority.DIRECTEUR_STRUCTURE,
		// 		Authority.RESPONSABLE_CENTRE,
		// 		Authority.PLANIFICATEUR,
		// 		Authority.CHARGE_MISSION
		// 	])
		// ) {
		// 	this.tabs.push({
		// 		name: 'Lieux de ' + labelIntervention,
		// 		path: '/gestion/mission-places/list',
		// 		parentPath: '/gestion/mission-places'
		// 	});
		// }

		// if (
		// 	this.facade.dataStorageService.isAreaActive() &&
		// 	this.userAsAnyAuthority([
		// 		Authority.DIRECTEUR_STRUCTURE,
		// 		Authority.RESPONSABLE_CENTRE,
		// 		Authority.PLANIFICATEUR
		// 	])
		// ) {
			// this.tabs.push({
			// 	name: 'Secteurs',
			// 	path: '/gestion/areas/list',
			// 	parentPath: '/gestion/areas'
			// });
		//}

		// if (
		// 	this.facade.dataStorageService.isVehiculeActive() &&
		// 	this.userAsAnyAuthority([
		// 		Authority.DIRECTEUR_STRUCTURE,
		// 		Authority.RESPONSABLE_CENTRE,
		// 		Authority.PLANIFICATEUR,
		// 		Authority.CHARGE_MISSION
		// 	])
		// ) {
			// this.tabs.push({
			// 	name: 'Véhicules',
			// 	path: '/gestion/vehicules/list',
			// 	parentPath: '/gestion/vehicules'
			// });
		//}

		// if (
		// 	this.userAsAnyAuthority([
		// 		Authority.DIRECTEUR_STRUCTURE,
		// 		Authority.RESPONSABLE_CENTRE,
		// 		Authority.PLANIFICATEUR
		// 	])
		// ) {
			this.tabs.push({
				name: 'Aménagement',
				path: '/parametrage/amenagement/list',
				parentPath: '/parametrage/amenagement'
			});
			this.tabs.push({
				name: 'Canal de communication',
				path: '/parametrage/canalCommunication/list',
				parentPath: '/parametrage/canalCommunication'
			});
			this.tabs.push({
				name: 'Département',
				path: '/parametrage/departement/list',
				parentPath: '/parametrage/departement'
			});
			this.tabs.push({
				name: 'Eligibilite bénéficiaire',
				path: '/parametrage/eligibiliteBeneficiaire/list',
				parentPath: '/parametrage/eligibiliteBeneficiaire'
			});
			this.tabs.push({
				name: "Expertise",
				path: '/parametrage/expertise/list',
				parentPath: '/parametrage/expertise'
			});
			this.tabs.push({
				name: 'Modalités de réunion',
				path: '/parametrage/modaliteReunion/list',
				parentPath: '/parametrage/modaliteReunion'
			});
			this.tabs.push({
				name: "Niveaux d'études",
				path: '/parametrage/niveauEtude/list',
				parentPath: '/parametrage/niveauEtude'
			});
			this.tabs.push({
				name: 'Niveau de qualification',
				path: '/parametrage/niveauQualification/list',
				parentPath: '/parametrage/niveauQualification'
			});
			this.tabs.push({
				name: 'Objectifs professionnels',
				path: '/parametrage/objectifPro/list',
				parentPath: '/parametrage/objectifPro'
			});
			this.tabs.push({
				name: 'Origines des demandes',
				path: '/parametrage/origineDemande/list',
				parentPath: '/parametrage/origineDemande'
			});
			this.tabs.push({
				name: 'Régions',
				path: '/parametrage/region/list',
				parentPath: '/parametrage/region'
			});
			this.tabs.push({
				name: 'Services',
				path: '/parametrage/service/list',
				parentPath: '/parametrage/service'
			});
			this.tabs.push({
				name: 'Situations',
				path: '/parametrage/situation/list',
				parentPath: '/parametrage/situation'
			});
			this.tabs.push({
				name: 'Situations familiales',
				path: '/parametrage/situationFamiliale/list',
				parentPath: '/parametrage/situationFamiliale'
			});
			this.tabs.push({
				name: 'Statut professionnel',
				path: '/parametrage/statutProfessionnel/list',
				parentPath: '/parametrage/statutProfessionnel'
			});
			this.tabs.push({
				name: 'Tâches finançables',
				path: '/parametrage/tache/list',
				parentPath: '/parametrage/tache'
			});
			this.tabs.push({
				name: 'Taux de reconnaissance',
				path: '/parametrage/tauxReconnaissance/list',
				parentPath: '/parametrage/tauxReconnaissance'
			});
			this.tabs.push({
				name: "Types de document",
				path: '/parametrage/typeDocument/list',
				parentPath: '/parametrage/typeDocument'
			});
			this.tabs.push({
				name: "Types d'entretien",
				path: '/parametrage/typeEntretien/list',
				parentPath: '/parametrage/typeEntretien'
			});
			this.tabs.push({
				name: "Types de formation",
				path: '/parametrage/typeFormation/list',
				parentPath: '/parametrage/typeFormation'
			});
			if(this.facade.dataStorageService.isAdmin){
				this.tabs.push({
					name: "Type de handicap",
					path: '/parametrage/typeHandicap/list',
					parentPath: '/parametrage/typeHandicap'
				});
			};
			this.tabs.push({
				name: 'Types de structure/Employeurs',
				path: '/parametrage/typeEntreprise/list',
				parentPath: '/parametrage/typeEntreprise'
			});
			this.tabs.push({
				name: 'Types de structure/Prescripteurs',
				path: '/parametrage/typeStructure/list',
				parentPath: '/parametrage/typeStructure'
			});
		//}
	}

	scrollTop() {
		window.scroll(0, 0);
	}

	userAsAnyAuthority(listAuthority: Authority[]) {
		return listAuthority.some((authority) => authority === this.user?.profile.id);
	}

	isRouterActive(path: string) {
		return this.router.isActive(path, false);
	}

	isRouterActiveForChild(path: string) {
		return this.router.isActive(path, false);
	}
}
